<a
  [attr.aria-label]="'Doe zoekopdracht naar ' + query()"
  [queryParamsHandling]="'replace'"
  [queryParams]="params(query())"
  [routerLink]="[basePath + searchResultsPage]"
  class="suggestion__content"
  wlKeyboardNavigationTarget
>
  <fa-icon icon="magnifying-glass" />
  @if (value()) {
    <div class="suggestion__text" [innerHTML]="value()"></div>
  } @else {
    <ng-content />
  }
</a>
